import { Container, Carousel, Image } from 'react-bootstrap'

const TakeAPeek = () => (
    <>
    <div className="section-take-a-peek">
        <Container>
            <h2 className="text-center">Take a peek at what's inside</h2>
            <Carousel interval={null}>
                <Carousel.Item>
                    <Image alt="Doctor What's Inside 1" src="../images/wyd/img-slide-whats-inside07.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="Doctor What's Inside 2" src="../images/wyd/img-slide-whats-inside02.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="Doctor What's Inside 3" src="../images/wyd/img-slide-whats-inside03.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="Doctor What's Inside 4" src="../images/wyd/img-slide-whats-inside04.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="Doctor What's Inside 5" src="../images/wyd/img-slide-whats-inside05.jpg"/>
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="Doctor What's Inside 6" src="../images/wyd/img-slide-whats-inside06.jpg"/>
                </Carousel.Item>
            </Carousel>
        </Container>
    </div>
    <style jsx global>{`

            .section-take-a-peek {
                background: url(../images/wyd/bg-scientist-doing-research01.jpg) no-repeat top right;
                font-size: 20px;
                background-size: cover;
            }

            .section-take-a-peek .container {
                padding-top: 50px;
                padding-bottom: 140px;
            }

            .section-take-a-peek h2 {
                color: #00aec7;
                font-size: 54px;
                margin-bottom: 45px;
                letter-spacing: 1px;
            }

            .section-take-a-peek .carousel {
                max-width: 467px;
                margin: 0px auto;
            }

            .section-take-a-peek .carousel .carousel-indicators {
                bottom: -60px;
            }

            .section-take-a-peek .carousel .carousel-indicators li {
                width: 16px;
                height: 16px;
                background: #b9b9b9;
                border: none;
                margin: 0px 4px;
                border-radius: 10px;
            }

            .section-take-a-peek .carousel .carousel-indicators .active {
                background: #00aec7;
            }

            .section-take-a-peek .carousel .carousel-control-prev,
            .section-take-a-peek .carousel .carousel-control-next {
                background: none;
                font-size: 34px;
                color: #00aec7;
                opacity: 1;
                text-shadow: none;
            }

            .section-take-a-peek .carousel .carousel-control span {
                position: absolute;
                top: 50%;
            }

            .section-take-a-peek .carousel .carousel-control-prev {
                left: -95px;
                color: #00aec7;
            }

            .section-take-a-peek .carousel .carousel-control-prev span {
                background: url(../images/wyd/img-prev01.png) no-repeat center center;
                height: 40px;
            }

            .section-take-a-peek .carousel .carousel-control-next {
                right: -100px;
            }

            .section-take-a-peek .carousel .carousel-control-next span {
                background: url(../images/wyd/img-next01.png) no-repeat center center;
                height: 40px;
            }

            @media (max-width: 767.98px) {	

                .section-take-a-peek .container {
                    padding-top: 30px;
                    padding-bottom: 80px;
                }

                .section-take-a-peek h2 {
                    font-size: 34px;
                    margin-bottom: 25px;
                }

                .section-take-a-peek .carousel .carousel-indicators {
                    bottom: -70px;
                }

                .section-take-a-peek .carousel .carousel-control-prev {
                    left: 15px;
                }

                .section-take-a-peek .carousel .carousel-control-next {
                    right: 0px;
                }

            }

        `}</style>
    </>
);

export default TakeAPeek;